export const PAPEIS = ['admin', 'atendente'] as const;
export type Papel = (typeof PAPEIS)[number];

export const STATUS_ATENDENTE = ['online', 'ausente', 'offline'] as const;
export type StatusAtendente = (typeof STATUS_ATENDENTE)[number];

export const STATUS_CONVERSA = ['bot', 'fila', 'atendimento', 'finalizada'] as const;
export type StatusConversa = (typeof STATUS_CONVERSA)[number];

export const ABAS = ['minhas', 'fila', 'equipe', 'ia'] as const;
export type Aba = (typeof ABAS)[number];

export const VEZ = ['responder', 'aguardando'] as const;
export type Vez = (typeof VEZ)[number];

export const AUTORES = ['cliente', 'ia', 'atendente', 'celular', 'sistema'] as const;
export type Autor = (typeof AUTORES)[number];

export const TIPOS_MENSAGEM = [
  'texto',
  'audio',
  'imagem',
  'video',
  'documento',
  'figurinha',
  'localizacao',
  'contato',
  'reacao',
] as const;
export type TipoMensagem = (typeof TIPOS_MENSAGEM)[number];

export const STATUS_ENTREGA = ['pendente', 'enviada', 'entregue', 'lida', 'erro'] as const;
export type StatusEntrega = (typeof STATUS_ENTREGA)[number];

export const ORIGENS = ['whatsapp', 'instagram', 'anuncio'] as const;
export type Origem = (typeof ORIGENS)[number];

export const FINALIZADA_POR = ['pedido_entregue', 'atendente'] as const;
export type FinalizadaPor = (typeof FINALIZADA_POR)[number];

export const ETAPAS_PEDIDO = [
  'orcamento',
  'pagamento',
  'arte',
  'aprovacao',
  'producao',
  'pronto',
  'enviado',
  'entregue',
] as const;
export type EtapaPedido = (typeof ETAPAS_PEDIDO)[number];

export const ROTULO_ETAPA: Record<EtapaPedido, string> = {
  orcamento: 'Orçamento',
  pagamento: 'Pagamento',
  arte: 'Arte',
  aprovacao: 'Aprovação',
  producao: 'Produção',
  pronto: 'Pronto',
  enviado: 'Enviado',
  entregue: 'Entregue',
};

export const STATUS_ORCAMENTO = [
  'coletando',
  'pronto',
  'enviado',
  'aprovado',
  'vencido',
  'perdido',
] as const;
export type StatusOrcamento = (typeof STATUS_ORCAMENTO)[number];

export const ORIGEM_MUDANCA = ['cliente', 'atendente', 'ia', 'os', 'tiny', 'sistema'] as const;
export type OrigemMudanca = (typeof ORIGEM_MUDANCA)[number];

export const DESTINOS_INTEGRACAO = ['tiny', 'os', 'tabela', 'whatsapp'] as const;
export type DestinoIntegracao = (typeof DESTINOS_INTEGRACAO)[number];

export const STATUS_EVENTO = ['pendente', 'ok', 'erro'] as const;
export type StatusEvento = (typeof STATUS_EVENTO)[number];

export const JANELA_WHATSAPP_MS = 24 * 60 * 60 * 1000;

export function janelaAberta(
  ultimaMensagemCliente: Date | string | null,
  agora = new Date(),
): boolean {
  if (!ultimaMensagemCliente) return false;
  const t = new Date(ultimaMensagemCliente).getTime();
  return agora.getTime() - t < JANELA_WHATSAPP_MS;
}
